module.exports = __webpack_public_path__ + "static/media/empty-image.5c78d531.svg";